// extracted by mini-css-extract-plugin
export default {"headerContainer":"Header_headerContainer__G1-oo","mainHeader":"Header_mainHeader__WJtck","imgContainer":"Header_imgContainer__QzMja"};